module.exports = __webpack_public_path__ + "static/media/header_image_06.2d5414a7.jpg";